<template>
  <div class="l-container">
    <div class="main-container">
      <div class="left-container">
        <LeftMenuHistory />
      </div>
      <div class="right-container">
        <div class="box-right">
          <header class="title">
            <h1>{{ title }}</h1>
            <a-divider class="divider-title divider-height" />
            <div class="back">
              <i class="icon icon-bor-arrow-left"></i>
              <a class="text-black" @click="gotoPath()">{{ backText }}</a>
            </div>
          </header>
          <a-divider />
          <CardMenu @gotoMap="scrollToMap($event)" class="mt-4" :cardObj="cardObj" :isShowBtnPublicStay="isShowBtnPublicStay" />
          <div ref="appDetail">
            <ApplicationDetails v-model="applicationDetail" />
          </div>
          <ApplicantInfor />
          <div ref="paymentInfo">
            <PaymentInfor :paymentInfo="paymentInfo" :cancelPolicy="cancelPolicy" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { LeftMenuHistory } from '@/components/compound'
import CardMenu from './CardMenu'
import ApplicationDetails from './ApplicationDetails'
import ApplicantInfor from './ApplicantInfor'
import PaymentInfor from './PaymentInfor'
import { GET_ORDER_DETAIL } from '@/store/modules/order/actions'
import { FROM_LIST_ORDER } from '@/store/modules/bs_myp/actions/'
import moment from 'moment'
import _ from 'lodash'

export default {
  components: {
    LeftMenuHistory,
    CardMenu,
    ApplicationDetails,
    ApplicantInfor,
    PaymentInfor
  },
  data() {
    return {
      breadcrumb_data: ['トップ ＞ マイページ', 'お申し込み履歴', 'お申し込み履歴詳細'],
      title: 'お申し込み履歴詳細',
      backText: 'お申し込み履歴一覧に戻る',
      orderStayDetail: null,
      acptNo: '',
      menuNo: '',
      planId: '',
      roomId: '',
      companyCd: '',
      imageUrl: '',
      useDate: '',
      endDate: '',
      totalAmt: '',
      pointUse: '',
      isShowBtnPublicStay: false,
      rpsntFamilyNmKana: '',
      rpsntFirstNmKana: '',
      resrvFamilyNmKana: '',
      resrvFirstNmKana: '',
      fullName: '',
      billAmtTotal: null,
      grantedBenepo: null,
      cancelPolicy: {},
      applicationDetail: {
        planNm: null,
        planLeadCopy: null,
        pointGrntNumAmt: null,
        useDate: null,
        endDate: null,
        fullName: null,
        acptDatetime: null,
        totalAmt: null,
        nightCnt: null
      },
      cardObj: {
        acptNo: null,
        acptDatetime: null,
        menuNo: null,
        billAmtTotal: null,
        pointGrntNumAmt: null,
        reserveSts: null,
        checkInDate: null,
        checkOutDate: null,
        cancelCloseUpDay: null,
        cancelCloseUpTime: null,
        webCancelAvailDiv: null
      },
      paymentInfo: {
        totalAmt: null,
        sbsidTotal: null,
        boneSbsidChrgTotal: null,
        pointUse: null,
        billAmtTotal: null,
        endDate: null,
        pointGrntNumAmt: null
      }
    }
  },
  computed: {
    loggedIn() {
      return this.$auth.loggedIn
    }
  },
  mounted() {
    if (this.loggedIn) {
      const { isPublicStay } = this.$route.query
      if (isPublicStay === 'true') {
        this.getOrderInfoPublicStay()
      } else {
        this.getOrderInfo()
      }
    } else {
      const params = {
        loggin: 1
      }
      this.$router.push({ path: '/', query: params })
    }
  },
  destroyed() {
    const fromListOrder = false
    this.$store.dispatch(FROM_LIST_ORDER, fromListOrder)
  },
  methods: {
    scrollToMap(index) {
      switch (index) {
      case 1:
        this.$smoothScroll({
          scrollTo: this.$refs.appDetail,
          offset: -10
        })
        return
      case 2:
        this.$smoothScroll({
          scrollTo: this.$refs.paymentInfo,
          offset: -10
        })
        return
      case 3:
        this.$smoothScroll({
          scrollTo: this.$refs.paymentInfo,
          offset: 700
        })
      }
    },
    getOrderInfoPublicStay() {
      const { acptNo } = this.$route.query
      this.acptNo = acptNo
      this.$repositories('order')
        .getOrderInfoPublicStay(acptNo)
        .then(
          (response) => {
            console.log('getOrderInfoPublicStay', response)
            const receivingMethod = _.get(response, 'orderPublicStayDetail.acptDtlList[0].stayAcptDtl.usageGuideReceiptDiv', null)
            if(!(receivingMethod > 0) && receivingMethod !== null) {
              this.isShowBtnPublicStay = true
            }
            this.handleResponseDataPublicStay(response)
          },
          (error) => {
            this.$toasted.error(error?.message)
          }
        )
    },
    getOrderInfo() {
      const { acptNo } = this.$route.query
      this.acptNo = acptNo
      this.$store.dispatch(GET_ORDER_DETAIL, acptNo).then((data) => {
        this.handleResponseData(data)
      })

      this.this.getPlanDetail()
    },
    getPlanDetail() {
      this.$repositories('plan')
        .getPlanDetail(this.menuNo, this.planId, this.roomId)
        .then((data) => {
          this.planDetail = data
          this.cancelPolicy = this.planDetail.cancelPolicy
          this.cardObj.cancelCloseUpDay = _.get(
            data,
            'cancelPolicy.cancelCloseUpDay',
            null
          )
          this.cardObj.cancelCloseUpTime = _.get(
            data,
            'cancelPolicy.cancelCloseUpTime',
            null
          )
          this.cardObj.webCancelAvailDiv = _.get(
            data,
            'cancelPolicy.webCancelAvailDiv',
            null
          )
          this.dataItem = {
            type: 'type-small',
            menu_id: _.get(data, 'menuInformation.menuNo', ''),
            label: _.get(data, 'menuInformation.categoryInfomation', ''),
            baseImg: _.get(data, 'roomBasicInfo.roomImages', ''),
            title3: _.get(data, 'menuInformation.menuNm', '')
          }
        })
    },
    gotoPath() {
      this.$router.push({ path: '/mypage/orders' })
    },
    handleResponseData(data) {
      console.log('data---------', data)
      if (data !== null) {
        this.menuNo = _.get(data, 'orderStayDetail.acptDtlList[0].acptDtl.menuNo', '')
        this.planId = _.get(data, 'orderStayDetail.acptDtlList[0].acptDtl.planId', '')
        this.roomId = _.get(
          data,
          'orderStayDetail.acptDtlList[0].acptPrticList[0].stayRoomDayPrticList[0].stayRoomDayPrtic.roomId',
          ''
        )
        this.companyCd = _.get(data, 'orderStayDetail.customer.companyCd', '')
        const checkInTm = _.get(
          data,
          'orderStayDetail.acptDtlList[0].acptDtl.useDate',
          ''
        )
        if (checkInTm) {
          this.useDate = moment(
            _.get(data, 'orderStayDetail.acptDtlList[0].acptDtl.useDate', '')
          ).format('YYYY/MM/DD')
          this.nightCnt = _.get(
            data,
            'orderStayDetail.acptDtlList[0].stayAcptDtl.nightCnt',
            null
          )
          if (this.useDate && this.nightCnt) {
            const date = new Date(this.useDate)
            date.setDate(date.getDate() + this.nightCnt)
            this.endDate = moment(date).format('YYYY/MM/DD')
          }
        }
        const acptTm = _.get(data, 'orderStayDetail.acpt.acptDatetime', null)
        this.totalAmt = _.get(data, 'orderStayDetail.acpt.totalAmt', '')
        this.sbsidTotal = _.get(data, 'orderStayDetail.acpt.aplySbsidAmt', '')
        this.pointUse = _.get(data, 'orderStayDetail.acpt.pointUseNumAmt', '')
        this.boneSbsidChrgTotal = _.get(
          data,
          'orderStayDetail.acptDtlList[0].dtlChrgTotal.boneSbsidChrgTotal',
          ''
        )
        this.billAmtTotal = _.get(data, 'orderStayDetail.acpt.billAmtTotal', '')
        console.log('billAmt', this.billAmtTotal)
        this.rpsntFamilyNmKana = _.get(
          data,
          'orderStayDetail.acptDtlList[0].stayResrvRpsntInfo.rpsntFamilyNm',
          ''
        )
        this.rpsntFirstNmKana = _.get(
          data,
          'orderStayDetail.acptDtlList[0].stayResrvRpsntInfo.rpsntFirstNm',
          ''
        )
        if (this.rpsntFamilyNmKana && this.rpsntFirstNmKana) {
          this.fullName = `${this.rpsntFirstNmKana} ${this.rpsntFamilyNmKana}`
        } else if (this.rpsntFamilyNmKana && !this.rpsntFirstNmKana) {
          this.fullName = this.rpsntFamilyNmKana
        } else if (!this.rpsntFamilyNmKana && this.rpsntFirstNmKana) {
          this.fullName = this.rpsntFirstNmKana
        } else {
          this.resrvFamilyNmKana = _.get(
            data,
            'orderStayDetail.acptDtlList[0].stayResrvRpsntInfo.resrvFamilyNmKana',
            ''
          )
          this.resrvFirstNmKana = _.get(
            data,
            'orderStayDetail.acptDtlList[0].stayResrvRpsntInfo.resrvFirstNmKana',
            ''
          )
          if (this.resrvFamilyNmKana && !this.resrvFirstNmKana) {
            this.fullName = this.resrvFamilyNmKana
          }
          if (!this.resrvFamilyNmKana && this.resrvFirstNmKana) {
            this.fullName = this.resrvFirstNmKana
          }
          if (this.resrvFamilyNmKana && this.resrvFirstNmKana) {
            this.fullName = this.resrvFirstNmKana + this.resrvFamilyNmKana
          }
        }
        const menuNo = this.menuNo
        const planId = this.planId
        // const billAmtTotal = _.get(data, 'orderStayDetail.acpt.billAmtTotal', '')
        const billingAmount = _.get(data, 'orderStayDetail.acpt.billAmtTotal', '')
        // console.log('billAmtTotal', billAmtTotal)
    
        this.$repositories('plan')
          .getGrantedBenepoStay({ menuNo, planId, billingAmount })
          .then(
            (response) => {
              this.grantedBenepo = response.grantedBenepo
              console.log('grantedBenepo: ', this.grantedBenepo)
              this.paymentInfo = {
                totalAmt: this.totalAmt,
                sbsidTotal: this.sbsidTotal,
                boneSbsidChrgTotal: this.boneSbsidChrgTotal,
                pointUse: this.pointUse,
                // billAmtTotal: this.billAmtTotal,
                billAmtTotal: this.billAmtTotal,
                endDate: this.endDate,
                // pointGrntNumAmt: _.get(data, 'orderStayDetail.acpt.pointGrntNumAmt', null)
                pointGrntNumAmt: this.grantedBenepo
              }
            },
            // eslint-disable-next-line no-unused-vars
            (error) => {
            // this.$toasted.error('コンパニオン登録に失敗しました')
            }
          )
          .catch((err) => {
            console.error('getGrantedBenepoStay', err)
          })
        

        this.cardObj = {
          acptNo: this.acptNo,
          acptDatetime: acptTm ? moment(acptTm).format('YYYY/MM/DD') : null,
          menuNo: _.get(
            data,
            'orderStayDetail.acptDtlList[0].menuBasicInfo.menuNo',
            null
          ),
          // billAmtTotal: _.get(data, 'orderStayDetail.acpt.billAmtTotal', ''),
          billAmtTotal: this.billAmtTotal,
          pointGrntNumAmt: _.get(data, 'orderStayDetail.acpt.pointGrntNumAmt', null),
          reserveSts: _.get(
            data,
            'orderStayDetail.acptDtlList[0].stayAcptDtl.resrvSts',
            null
          ),
          checkInDate: this.useDate,
          checkOutDate: this.endDate,
          cancelCloseUpDay: null,
          cancelCloseUpTime: null,
          webCancelAvailDiv: null
        }
        this.applicationDetail = {
          planNm: _.get(
            data,
            'orderStayDetail.acptDtlList[0].planBasicInfo.planNm',
            null
          ),
          planLeadCopy: _.get(
            data,
            'orderStayDetail.acptDtlList[0].planBasicInfo.planLeadCopy',
            null
          ),
          pointGrntNumAmt: _.get(data, 'orderStayDetail.acpt.pointGrntNumAmt', null),
          useDate: _.get(data, 'orderStayDetail.acptDtlList[0].acptDtl.useDate', null),
          endDate: this.endDate,
          fullName: this.fullName,
          nightCnt: _.get(
            data,
            'orderStayDetail.acptDtlList[0].stayAcptDtl.nightCnt',
            null
          ),
          acptDatetime: acptTm ? moment(acptTm).format('YYYY/MM/DD HH:mm') : null,
          // billAmtTotal: _.get(data, 'orderStayDetail.acpt.billAmtTotal', '')
          billAmtTotal: this.billAmtTotal
        }
        // this.paymentInfo = {
        //   totalAmt: this.totalAmt,
        //   sbsidTotal: this.sbsidTotal,
        //   boneSbsidChrgTotal: this.boneSbsidChrgTotal,
        //   pointUse: this.pointUse,
        //   // billAmtTotal: this.billAmtTotal,
        //   billAmtTotal: this.billAmtTotal,
        //   endDate: this.endDate,
        //   // pointGrntNumAmt: _.get(data, 'orderStayDetail.acpt.pointGrntNumAmt', null)
        //   pointGrntNumAmt: this.grantedBenepo
        // }
      }
    },
    handleResponseDataPublicStay(data) {
      if (data !== null) {
        this.menuNo = _.get(
          data,
          'orderPublicStayDetail.acptDtlList[0].acptDtl.menuNo',
          ''
        )
        this.planId = _.get(
          data,
          'orderPublicStayDetail.acptDtlList[0].acptDtl.planId',
          ''
        )
        this.roomId = _.get(
          data,
          'orderPublicStayDetail.acptDtlList[0].acptPrticList[0].stayRoomDayPrticList[0].stayRoomDayPrtic.roomId',
          ''
        )
        this.companyCd = _.get(data, 'orderPublicStayDetail.customer.companyCd', '')
        const checkInTm = _.get(
          data,
          'orderPublicStayDetail.acptDtlList[0].acptDtl.useDate',
          ''
        )
        if (checkInTm) {
          this.useDate = moment(
            _.get(data, 'orderPublicStayDetail.acptDtlList[0].acptDtl.useDate', '')
          ).format('YYYY/MM/DD')
          this.nightCnt = _.get(
            data,
            'orderPublicStayDetail.acptDtlList[0].stayAcptDtl.nightCnt',
            null
          )
          if (this.useDate && this.nightCnt) {
            const date = new Date(this.useDate)
            date.setDate(date.getDate() + this.nightCnt)
            this.endDate = moment(date).format('YYYY/MM/DD')
          }
        }
        const acptTm = _.get(data, 'orderPublicStayDetail.acpt.acptDatetime', null)
        this.totalAmt = _.get(data, 'orderPublicStayDetail.acpt.totalAmt', '')
        this.sbsidTotal = _.get(data, 'orderPublicStayDetail.acpt.aplySbsidAmt', '')
        this.pointUse = _.get(data, 'orderPublicStayDetail.acpt.pointUseNumAmt', '')
        this.boneSbsidChrgTotal = _.get(
          data,
          'orderPublicStayDetail.acptDtlList[0].dtlChrgTotal.boneSbsidChrgTotal',
          ''
        )
        this.billAmtTotal = _.get(data, 'orderPublicStayDetail.acpt.billAmtTotal', '')
        this.rpsntFamilyNmKana = _.get(
          data,
          'orderPublicStayDetail.acptDtlList[0].stayResrvRpsntInfo.rpsntFamilyNm',
          ''
        )
        this.rpsntFirstNmKana = _.get(
          data,
          'orderPublicStayDetail.acptDtlList[0].stayResrvRpsntInfo.rpsntFirstNm',
          ''
        )
        if (this.rpsntFamilyNmKana && this.rpsntFirstNmKana) {
          this.fullName = `${this.rpsntFirstNmKana} ${this.rpsntFamilyNmKana}`
        } else if (this.rpsntFamilyNmKana && !this.rpsntFirstNmKana) {
          this.fullName = this.rpsntFamilyNmKana
        } else if (!this.rpsntFamilyNmKana && this.rpsntFirstNmKana) {
          this.fullName = this.rpsntFirstNmKana
        } else {
          this.resrvFamilyNmKana = _.get(
            data,
            'orderPublicStayDetail.acptDtlList[0].stayResrvRpsntInfo.resrvFamilyNmKana',
            ''
          )
          this.resrvFirstNmKana = _.get(
            data,
            'orderPublicStayDetail.acptDtlList[0].stayResrvRpsntInfo.resrvFirstNmKana',
            ''
          )
          if (this.resrvFamilyNmKana && !this.resrvFirstNmKana) {
            this.fullName = this.resrvFamilyNmKana
          }
          if (!this.resrvFamilyNmKana && this.resrvFirstNmKana) {
            this.fullName = this.resrvFirstNmKana
          }
          if (this.resrvFamilyNmKana && this.resrvFirstNmKana) {
            this.fullName = this.resrvFirstNmKana + this.resrvFamilyNmKana
          }
        }

        this.cardObj = {
          acptNo: this.acptNo,
          acptDatetime: acptTm ? moment(acptTm).format('YYYY/MM/DD') : null,
          menuNo: _.get(
            data,
            'orderPublicStayDetail.acptDtlList[0].menuBasicInfo.menuNo',
            null
          ),
          // billAmtTotal: _.get(data, 'orderPublicStayDetail.acpt.billAmtTotal', ''),
          billAmtTotal: this.billAmtTotal,
          pointGrntNumAmt: _.get(
            data,
            'orderPublicStayDetail.acpt.pointGrntNumAmt',
            null
          ),
          reserveSts: _.get(
            data,
            'orderPublicStayDetail.acptDtlList[0].stayAcptDtl.resrvSts',
            null
          ),
          checkInDate: this.useDate,
          checkOutDate: this.endDate,
          cancelCloseUpDay: null,
          cancelCloseUpTime: null,
          webCancelAvailDiv: null
        }

        this.applicationDetail = {
          planNm: _.get(
            data,
            'orderPublicStayDetail.acptDtlList[0].planBasicInfo.planNm',
            null
          ),
          planLeadCopy: _.get(
            data,
            'orderPublicStayDetail.acptDtlList[0].planBasicInfo.planLeadCopy',
            null
          ),
          pointGrntNumAmt: _.get(
            data,
            'orderPublicStayDetail.acpt.pointGrntNumAmt',
            null
          ),
          useDate: _.get(
            data,
            'orderPublicStayDetail.acptDtlList[0].acptDtl.useDate',
            null
          ),
          endDate: this.endDate,
          fullName: this.fullName,
          nightCnt: _.get(
            data,
            'orderPublicStayDetail.acptDtlList[0].stayAcptDtl.nightCnt',
            null
          ),
          acptDatetime: acptTm ? moment(acptTm).format('YYYY/MM/DD HH:mm') : null,
          // billAmtTotal: _.get(data, 'orderPublicStayDetail.acpt.billAmtTotal', '')
          billAmtTotal: this.billAmtTotal
        }

        this.paymentInfo = {
          totalAmt: this.totalAmt,
          sbsidTotal: this.sbsidTotal,
          boneSbsidChrgTotal: this.boneSbsidChrgTotal,
          pointUse: this.pointUse,
          // billAmtTotal: this.billAmtTotal,
          billAmtTotal: this.billAmtTotal,
          endDate: this.endDate,
          pointGrntNumAmt: _.get(data, 'orderPublicStayDetail.acpt.pointGrntNumAmt', null)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import './styles.scss';
</style>
